/*
 * Cart tier bar — progress towards order discounts (e.g. 200 / 600 / 900 zł) + "voucher to every order" info,
 * injected into the ReCharge cart drawer (shadow DOM), same approach as gift-with-purchase-drawer.js.
 *
 * The discounts themselves are Shopify automatic discounts set up in Admin; this script only shows the
 * progress and reads the applied discount back from /cart.js. The voucher is not a cart line: the
 * fulfilment team adds it to every order, the drawer only informs about it.
 *
 * Config: window.nkTierBar (snippets/cart-tier-bar.liquid, theme settings "Pasek rabatów w koszyku").
 * Design: Claude Design "Koszyk Drawer Black Month" (the campaign name is internal, never shown to customers).
 */
(function () {
  'use strict';

  var CFG = window.nkTierBar;
  if (!CFG || !CFG.enabled) return;

  var TIERS = (CFG.tiers || [])
    .filter(function (t) { return t && t.min > 0 && t.pct > 0; })
    .sort(function (a, b) { return a.min - b.min; });
  if (!TIERS.length) return;

  var VOUCHER = CFG.voucher || {};
  var CURRENCY = CFG.currency || 'PLN';

  /* Products that do not count towards the tiers (the Shopify discount excludes them too).
     Collections are read from their public JSON; explicit handles come from the config. */
  var excluded = {};

  function fetchCollectionHandles(handle) {
    var out = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n, {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = d.products || [];
          list.forEach(function (p) { out.push(p.handle); });
          return list.length ? page(n + 1) : out;
        });
    }
    return page(1);
  }

  // Diagnostics, readable in the console as window.nkTierBar.excluded / .exclusionErrors / .eligibleSub
  CFG.excluded = excluded;
  CFG.exclusionErrors = [];

  // Defaults hold even when the page's snippet predates these settings.
  var EXCLUDE_COLLECTIONS = CFG.excludeCollections || ['ksiazki', 'nikalab-limited-edition'];
  var EXCLUDE_HANDLES = CFG.excludeHandles || ['karta-podarunkowa-nikalab'];

  var exclusionsReady = Promise.all(EXCLUDE_COLLECTIONS.map(function (c) {
    return fetchCollectionHandles(c).catch(function (e) {
      CFG.exclusionErrors.push(c + ': ' + String(e));
      return [];
    });
  })).then(function (lists) {
    [].concat(EXCLUDE_HANDLES, [].concat.apply([], lists)).forEach(function (h) { excluded[h] = true; });
  });

  var ICON_GIFT = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.5-3-5-3.5-5-1.2C7 8 9.5 8 12 8zm0 0c1.5-3 5-3.5 5-1.2C17 8 14.5 8 12 8z"/></svg>';
  var ICON_X = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var CSS = [
    '[data-nk-tb],[data-nk-tb] *{box-sizing:border-box;letter-spacing:0;font-family:studiofeixen,sans-serif}',
    '[data-nk-tb][hidden],[data-nk-tb] [hidden]{display:none!important}',
    '#cart-drawer{position:relative}',

    /* tracker (top of the scroll area, full width, white) */
    '#cart-drawer > div:has(> .nk-tb){padding-top:0!important;justify-content:flex-start!important;align-items:stretch!important}',
    /* empty cart: ReCharge centres "Twój koszyk jest pusty" in the middle of the drawer; the design shows it as a
       card under the tracker and the voucher */
    '#cart-drawer > div:has(> .nk-tb) > .dynamic-richtext{margin:0 24px;padding:58px 20px 24px!important;border-radius:6px;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2726%27 height=%2726%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23244545%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8L5 8z%27/%3E%3Cpath d=%27M9 8V6.5a3 3 0 0 1 6 0V8%27/%3E%3C/svg%3E") center 24px no-repeat;text-align:center}',
    '#cart-drawer > div:has(> .nk-tb) > .dynamic-richtext h2{margin:0!important;font-size:18px!important;line-height:23px!important;font-weight:400!important;letter-spacing:0!important;color:#244545!important}',
    '#cart-drawer > div:has(> .nk-tb) > .dynamic-richtext + div{display:flex;justify-content:center;margin-top:16px}',
    '.nk-tb{padding:14px 24px;background:#fff;color:#244545}',
    '.nk-tb__top{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}',
    '.nk-tb__msg{flex:1;min-width:0;margin:-4px -8px 0;padding:4px 8px;border-radius:4px;font-size:14px;line-height:19px;font-weight:400;min-height:19px;text-wrap:pretty;transition:background .6s cubic-bezier(.2,.7,.2,1)}',
    '.nk-tb__msg b{font-weight:800;white-space:nowrap}',
    '.nk-tb__msg.is-flash{background:#ECF166}',
    '.nk-tb__rules{flex:none;margin:-2px -6px 0 0;padding:4px 6px;border:0;background:transparent;cursor:pointer;font-size:10px;line-height:15px;font-weight:400;white-space:nowrap;color:#3C4B4B;text-decoration:underline;text-underline-offset:2px}',
    '.nk-tb__rules:hover{color:#244545}',
    '.nk-tb__scale{position:relative;margin:14px 10px 6px 0}',
    '.nk-tb__row{display:grid;grid-template-columns:repeat(var(--nk-n),minmax(0,1fr))}',
    '.nk-tb__row span{justify-self:end;transform:translateX(7px);white-space:nowrap;line-height:1}',
    '.nk-tb__min{font-size:12px;font-weight:400;color:#3C4B4B}',
    /* reached tiers take their own shade of green (--nk-shade, set per tier), the rest stay grey */
    '.nk-tb__pct{font-size:20px;letter-spacing:-.01em;font-weight:800;color:#6D7878;transition:color .2s}',
    '.nk-tb__pct.is-on{color:var(--nk-shade)}',
    '.nk-tb__track{position:relative;margin:10px 0;height:6px;border-radius:54px;background:#F3F4F4}',
    '.nk-tb__fill{position:absolute;left:0;top:0;bottom:0;border-radius:54px;background:linear-gradient(90deg,#BDC7C7,#244545);transition:width .3s cubic-bezier(.2,.7,.2,1)}',
    '.nk-tb__dot{position:absolute;top:50%;width:16px;height:16px;border-radius:54px;transform:translate(-50%,-50%);background:#fff;border:1.5px solid #CED2D2;transition:background .2s,border-color .2s,box-shadow .3s cubic-bezier(.2,.7,.2,1)}',
    '.nk-tb__dot.is-on{background:var(--nk-shade);border-color:#fff}',
    '.nk-tb__dot.is-top{box-shadow:0 0 0 5px rgba(36,69,69,.15)}',

    /* gift card info (styled like a drawer line item, not a real cart line; tile matches ReCharge's 80px line item image) */
    '.nk-tb-voucher{display:flex;gap:12px;margin:12px 24px;padding:8px;border-radius:6px;background:#fff;color:#244545;animation:nk-tb-in .32s cubic-bezier(.2,.7,.2,1) both}',
    '.nk-tb-voucher.is-empty{align-items:center}',
    '.nk-tb-voucher__tile{flex:none;width:80px;height:80px;border-radius:4px;background:#ECF166;display:flex;align-items:center;justify-content:center;overflow:hidden}',
    '.nk-tb-voucher__tile img{display:block;width:80px;height:auto}',
    '.nk-tb-voucher__body{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px;padding-top:6px}',
    '.nk-tb-voucher.is-empty .nk-tb-voucher__body{padding-top:0}',
    '.nk-tb-voucher__head{display:flex;justify-content:space-between;align-items:baseline;gap:8px}',
    '.nk-tb-voucher__title{font-size:16px;line-height:21px;font-weight:400}',
    '.nk-tb-voucher__badge{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:14px;line-height:1;font-weight:600;white-space:nowrap}',
    '.nk-tb-voucher__sub{font-size:clamp(11px,3.1vw,12px);line-height:16px;font-weight:400;white-space:nowrap;color:#3C4B4B}',
    '.nk-tb-voucher__sub--gift{display:flex;align-items:center;gap:5px;line-height:17px;font-weight:600;color:#244545}',
    '@keyframes nk-tb-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',

    /* footer: progress line + next tier reminder once the tracker is scrolled away, applied discount */
    '#cart-drawer footer{position:relative}',
    '.nk-tb-foot{padding:0 24px}',
    '.nk-tb-foot__line{position:absolute;left:0;right:0;top:0;height:3px;background:#F7F4E9;opacity:0;transition:opacity .2s cubic-bezier(.2,.7,.2,1)}',
    '.nk-tb-foot__line i{display:block;height:100%;background:#244545;transition:width .3s cubic-bezier(.2,.7,.2,1)}',
    '.nk-tb-foot.is-away .nk-tb-foot__line{opacity:1}',
    '.nk-tb-foot__next{display:none;margin:-4px 0 12px;padding-bottom:12px;border-bottom:1px solid #E7E8E8;font-size:12px;line-height:17px;font-weight:400;color:#3C4B4B}',
    '.nk-tb-foot.is-away .nk-tb-foot__next.has-next{display:block}',
    '.nk-tb-foot__next b{font-weight:500;color:#244545}',
    '.nk-tb-foot__save{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:8px;font-size:12px;line-height:17px;font-weight:400;color:#244545}',
    '.nk-tb-foot__save[hidden]{display:none}',
    '.nk-tb-foot__save > span{display:flex;align-items:center;gap:6px}',
    '.nk-tb-foot__save b{white-space:nowrap;font-weight:500}',
    '.nk-tb-code{font-size:10px;line-height:1;font-weight:500;letter-spacing:.08em;border:1px dashed #244545;border-radius:3px;padding:2px 4px}',

    /* rules bottom sheet */
    '.nk-tb-sheet{position:absolute;inset:0;z-index:20}',
    '.nk-tb-sheet[hidden]{display:none}',
    '.nk-tb-sheet__scrim{position:absolute;inset:0;background:rgba(11,30,30,.45);animation:nk-tb-fade .18s cubic-bezier(.2,.7,.2,1) both}',
    '.nk-tb-sheet__panel{position:absolute;left:0;right:0;bottom:0;background:#fff;border-radius:16px 16px 0 0;padding:8px 20px 24px;color:#244545;animation:nk-tb-in .24s cubic-bezier(.2,.7,.2,1) both}',
    '.nk-tb-sheet__grip{width:36px;height:4px;border-radius:54px;background:#E7E8E8;margin:0 auto 14px}',
    '.nk-tb-sheet__head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px}',
    '.nk-tb-sheet__title{font-size:25px;line-height:30px;font-weight:400}',
    '.nk-tb-sheet__close{width:44px;height:44px;margin:-10px -12px -10px 0;border:0;background:transparent;border-radius:54px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#244545}',
    '.nk-tb-sheet__close:hover{background:#F3F4F4}',
    '.nk-tb-sheet__body{max-height:min(62vh,520px);overflow-y:auto;margin:0 -20px;padding:0 20px}',
    '.nk-tb-sheet__h{font-size:18px;line-height:23px;font-weight:600;margin:8px 0 14px}',
    '.nk-tb-sheet__h--voucher{margin:0 0 14px;padding-top:24px;border-top:1px solid #E7E8E8}',
    '.nk-tb-table{margin-bottom:14px}',
    '.nk-tb-table__row{display:grid;grid-template-columns:1.4fr 1fr 1fr;align-items:center;padding:12px 0;border-bottom:1px solid #E7E8E8;font-size:14px;line-height:19px;font-weight:400}',
    '.nk-tb-table__row b{font-weight:800}',
    '.nk-tb-table__row--head{padding:0 0 10px;font-size:12px;line-height:17px;color:#3C4B4B}',
    '.nk-tb-rte{display:flex;flex-direction:column;gap:14px;font-size:14px;line-height:19px;font-weight:400;color:#244545;margin-bottom:20px}',
    '.nk-tb-rte p,.nk-tb-rte ul{margin:0;text-wrap:pretty}',
    '.nk-tb-rte ul{padding:0 0 0 16px;display:flex;flex-direction:column;gap:6px;list-style:disc}',
    '.nk-tb-rte li{display:list-item}',
    '.nk-tb-rte:last-child{margin-bottom:0}',
    '@keyframes nk-tb-fade{from{opacity:0}to{opacity:1}}',
    '@media (prefers-reduced-motion:reduce){[data-nk-tb],[data-nk-tb] *{animation:none!important;transition:none!important}}',
    '@media (max-width:749px){.nk-tb{padding:14px 20px}.nk-tb-voucher{margin:12px 20px}.nk-tb-foot{padding:0 20px}}'
  ].join('\n');

  /* ------------------------------------------------------------------ helpers */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // grosze → "1 234,50"
  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function zl(cents) { return money(cents) + ' zł'; }

  function tierState(sub) {
    var cur = null, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (sub >= TIERS[i].min * 100) cur = TIERS[i];
      else if (!next) next = TIERS[i];
    }
    return { cur: cur, next: next, idx: cur ? TIERS.indexOf(cur) + 1 : 0 };
  }

  // Every tier owns an equal slice of the bar, filled proportionally between the previous and its own threshold.
  function barPct(sub) {
    var k = 0;
    for (var i = 0; i < TIERS.length; i++) {
      var lo = i ? TIERS[i - 1].min * 100 : 0;
      var hi = TIERS[i].min * 100;
      k += Math.max(0, Math.min(1, (sub - lo) / (hi - lo)));
    }
    return k / TIERS.length * 100;
  }

  function messageHtml(sub, st) {
    var pct = function (t) { return '<b>-' + t.pct + '%</b>'; };
    if (!st.cur && sub <= 0) return 'Dodaj produkty za <b>' + TIERS[0].min + ' zł</b> i odbierz ' + pct(TIERS[0]);
    if (!st.cur) return 'Dodaj jeszcze za <b>' + zl(st.next.min * 100 - sub) + '</b> i odbierz ' + pct(st.next);
    if (st.next) return 'Masz już -' + st.cur.pct + '%. Dodaj za <b>' + zl(st.next.min * 100 - sub) + '</b> i odbierz ' + pct(st.next);
    return 'Masz najwyższy rabat ' + pct(st.cur);
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    n.setAttribute('data-nk-tb', '');
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ------------------------------------------------------------------ building blocks */

  // Brand green mixed with white: the top tier is full green, each lower one 20% lighter (60/80/100% for 3 tiers).
  function tierShade(i) {
    var k = Math.max(0.2, 1 - (TIERS.length - 1 - i) * 0.2);
    return '#' + [0x24, 0x45, 0x45].map(function (c) {
      return ('0' + Math.round(c * k + 255 * (1 - k)).toString(16)).slice(-2);
    }).join('');
  }

  function buildTracker() {
    var n = TIERS.length;
    var mins = '', pcts = '', dots = '';
    TIERS.forEach(function (t, i) {
      var shade = '--nk-shade:' + tierShade(i);
      mins += '<span class="nk-tb__min">od ' + t.min + ' zł</span>';
      pcts += '<span class="nk-tb__pct" style="' + shade + '">-' + t.pct + '%</span>';
      dots += '<div class="nk-tb__dot" style="left:' + ((i + 1) / n * 100) + '%;' + shade + '"></div>';
    });
    var t = el('div', 'nk-tb',
      '<div class="nk-tb__top">' +
        '<div class="nk-tb__msg" aria-live="polite"></div>' +
        '<button type="button" class="nk-tb__rules" aria-haspopup="dialog">zasady</button>' +
      '</div>' +
      '<div class="nk-tb__scale" style="--nk-n:' + n + '">' +
        '<div class="nk-tb__row">' + mins + '</div>' +
        '<div class="nk-tb__track"><div class="nk-tb__fill"></div>' + dots + '</div>' +
        '<div class="nk-tb__row">' + pcts + '</div>' +
      '</div>');
    t.querySelector('.nk-tb__rules').addEventListener('click', function () { openSheet(t.getRootNode()); });
    return t;
  }

  function buildVoucher() {
    return el('div', 'nk-tb-voucher',
      '<div class="nk-tb-voucher__tile"><img src="' + esc(VOUCHER.image) + '" alt="' + esc(VOUCHER.title) + '" width="80" height="57" decoding="async"></div>' +
      '<div class="nk-tb-voucher__body">' +
        '<div class="nk-tb-voucher__head"><span class="nk-tb-voucher__title">' + esc(VOUCHER.title) + '</span>' +
          '<span class="nk-tb-voucher__badge">' + ICON_GIFT + esc(VOUCHER.badge) + '</span></div>' +
        '<span class="nk-tb-voucher__sub"></span>' +
      '</div>');
  }

  function buildFoot() {
    return el('div', 'nk-tb-foot',
      '<div class="nk-tb-foot__line"><i></i></div>' +
      '<div class="nk-tb-foot__next"></div>' +
      '<div class="nk-tb-foot__save" hidden><span>Oszczędzasz z kodem <span class="nk-tb-code"></span></span><b></b></div>');
  }

  function buildSheet() {
    var rows = TIERS.map(function (t) {
      return '<div class="nk-tb-table__row"><span>od ' + t.min + ' zł</span><b>' + t.pct + '%</b><span>' + esc(t.code) + '</span></div>';
    }).join('');
    var s = el('div', 'nk-tb-sheet',
      '<div class="nk-tb-sheet__scrim"></div>' +
      '<div class="nk-tb-sheet__panel" role="dialog" aria-modal="true" aria-label="' + esc(CFG.rulesTitle) + '">' +
        '<div class="nk-tb-sheet__grip"></div>' +
        '<div class="nk-tb-sheet__head"><span class="nk-tb-sheet__title">' + esc(CFG.rulesTitle) + '</span>' +
          '<button type="button" class="nk-tb-sheet__close" aria-label="Zamknij">' + ICON_X + '</button></div>' +
        '<div class="nk-tb-sheet__body">' +
          (CFG.rulesDiscountTitle ? '<div class="nk-tb-sheet__h">' + esc(CFG.rulesDiscountTitle) + '</div>' : '') +
          '<div class="nk-tb-table"><div class="nk-tb-table__row nk-tb-table__row--head"><span>Wartość koszyka</span><span>Rabat</span><span>' + (TIERS.some(function (t) { return t.code; }) ? 'Kod' : '') + '</span></div>' + rows + '</div>' +
          '<div class="nk-tb-rte">' + (CFG.rulesDiscount || '') + '</div>' +
          (VOUCHER.enabled ? '<div class="nk-tb-sheet__h nk-tb-sheet__h--voucher">' + esc(CFG.rulesVoucherTitle) + '</div><div class="nk-tb-rte">' + (CFG.rulesVoucher || '') + '</div>' : '') +
        '</div>' +
      '</div>');
    s.hidden = true;
    s.querySelector('.nk-tb-sheet__scrim').addEventListener('click', function () { s.hidden = true; });
    s.querySelector('.nk-tb-sheet__close').addEventListener('click', function () { s.hidden = true; });
    return s;
  }

  function openSheet(sr) {
    var s = sr.querySelector('.nk-tb-sheet');
    if (!s) return;
    s.hidden = false;
    var close = s.querySelector('.nk-tb-sheet__close');
    if (close) close.focus();
  }

  /* ------------------------------------------------------------------ drawer wiring */

  var lastCart = null;
  var lastIdx = null;
  var flashTimer = null;

  function ensureStyle(sr) {
    if (sr.querySelector('#nk-tb-css')) return;
    var st = document.createElement('style');
    st.id = 'nk-tb-css';
    st.textContent = CSS;
    sr.appendChild(st);
  }

  function scrollArea(drawer) {
    for (var i = 0; i < drawer.children.length; i++) {
      var c = drawer.children[i];
      if (c.tagName === 'DIV' && /\boverflow-y-auto\b/.test(c.className)) return c;
    }
    return null;
  }

  function trackerAway(area, tracker) {
    return area.scrollTop > tracker.offsetTop + tracker.offsetHeight * 0.65;
  }

  // Keep our nodes where they belong: ReCharge (React) re-renders its own nodes and may drop ours.
  function place(sr) {
    var drawer = sr.querySelector('#cart-drawer');
    if (!drawer) return null;
    var area = scrollArea(drawer);
    if (!area) return null;

    var tracker = area.querySelector(':scope > .nk-tb') || buildTracker();
    if (area.firstElementChild !== tracker) area.insertBefore(tracker, area.firstElementChild);

    var voucher = area.querySelector(':scope > .nk-tb-voucher');
    if (VOUCHER.enabled) {
      if (!voucher) voucher = buildVoucher();
      if (tracker.nextElementSibling !== voucher) area.insertBefore(voucher, tracker.nextElementSibling);
    } else if (voucher) {
      voucher.remove();
      voucher = null;
    }

    var footer = drawer.querySelector(':scope > footer');
    var foot = null;
    if (footer) {
      foot = footer.querySelector(':scope > .nk-tb-foot') || buildFoot();
      if (footer.firstElementChild !== foot) footer.insertBefore(foot, footer.firstElementChild);
    }

    if (!drawer.querySelector(':scope > .nk-tb-sheet')) drawer.appendChild(buildSheet());

    if (!area.nkTbScroll) {
      area.nkTbScroll = true;
      area.addEventListener('scroll', function () {
        var t = area.querySelector(':scope > .nk-tb');
        var f = drawer.querySelector(':scope > footer > .nk-tb-foot');
        if (t && f) f.classList.toggle('is-away', trackerAway(area, t));
      }, { passive: true });
    }
    if (foot) foot.classList.toggle('is-away', trackerAway(area, tracker));

    return { drawer: drawer, tracker: tracker, voucher: voucher, foot: foot };
  }

  function render(sr, cart) {
    var nodes = place(sr);
    if (!nodes) return;
    var on = cart.currency === CURRENCY;
    [nodes.tracker, nodes.voucher, nodes.foot].forEach(function (n) { if (n) n.hidden = !on; });
    if (!on) return;

    var sub = eligibleSubtotal(cart);
    CFG.eligibleSub = sub;
    var st = tierState(sub);
    var empty = !cart.item_count;

    var msg = nodes.tracker.querySelector('.nk-tb__msg');
    var html = messageHtml(empty ? 0 : sub, st);
    if (msg.innerHTML !== html) msg.innerHTML = html;
    if (lastIdx !== null && st.idx > lastIdx) {
      msg.classList.add('is-flash');
      clearTimeout(flashTimer);
      flashTimer = setTimeout(function () { msg.classList.remove('is-flash'); }, 1400);
    }
    lastIdx = st.idx;

    nodes.tracker.querySelector('.nk-tb__fill').style.width = barPct(sub) + '%';
    var dots = nodes.tracker.querySelectorAll('.nk-tb__dot');
    var pcts = nodes.tracker.querySelectorAll('.nk-tb__pct');
    TIERS.forEach(function (t, i) {
      var reached = sub >= t.min * 100;
      dots[i].classList.toggle('is-on', reached);
      dots[i].classList.toggle('is-top', t === st.cur);
      pcts[i].classList.toggle('is-on', reached);
    });

    if (nodes.voucher) {
      var vsub = nodes.voucher.querySelector('.nk-tb-voucher__sub');
      var badge = nodes.voucher.querySelector('.nk-tb-voucher__badge');
      nodes.voucher.classList.toggle('is-empty', empty);
      badge.hidden = empty;
      if (empty) {
        vsub.className = 'nk-tb-voucher__sub nk-tb-voucher__sub--gift';
        vsub.innerHTML = ICON_GIFT + esc(VOUCHER.subtitleEmpty);
      } else {
        vsub.className = 'nk-tb-voucher__sub';
        vsub.textContent = VOUCHER.subtitle || '';
      }
    }

    if (nodes.foot) {
      var top = TIERS[TIERS.length - 1].min * 100;
      nodes.foot.querySelector('.nk-tb-foot__line i').style.width = Math.min(sub / top, 1) * 100 + '%';
      var next = nodes.foot.querySelector('.nk-tb-foot__next');
      next.classList.toggle('has-next', !!st.next && !empty);
      next.innerHTML = st.next ? 'Jeszcze <b>' + zl(st.next.min * 100 - sub) + '</b> do <b>-' + st.next.pct + '%</b>' : '';

      // Applied tier discount as Shopify reports it (automatic discount title = code shown).
      var apps = appliedDiscounts(cart);
      var save = nodes.foot.querySelector('.nk-tb-foot__save');
      save.hidden = !apps.length;
      if (apps.length) {
        save.querySelector('.nk-tb-code').textContent = apps.map(function (a) { return a.title; }).join(' + ');
        save.querySelector('b').textContent = '-' + zl(apps.reduce(function (s, a) { return s + a.amount; }, 0));
      }
    }
  }

  // Subtotal of the lines that count towards the tiers (after product discounts, without excluded products).
  function eligibleSubtotal(cart) {
    return (cart.items || []).reduce(function (s, item) {
      if (excluded[item.handle]) return s;
      return s + (item.final_line_price != null ? item.final_line_price : item.line_price);
    }, 0);
  }

  // Discounts applied to the cart: order-level ones plus line-level ones that are tier discounts
  // (product-level discounts, e.g. "Amount off products", are reported per line, not per cart).
  function appliedDiscounts(cart) {
    var codes = TIERS.map(function (t) { return t.code; }).filter(Boolean);
    var byTitle = {}, list = [];
    function add(title, amount) {
      if (!(amount > 0)) return;
      if (!byTitle[title]) { byTitle[title] = { title: title, amount: 0 }; list.push(byTitle[title]); }
      byTitle[title].amount += amount;
    }
    (cart.cart_level_discount_applications || []).forEach(function (a) { add(a.title, a.total_allocated_amount); });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (d) {
        var title = d.discount_application && d.discount_application.title;
        if (codes.indexOf(title) !== -1) add(title, d.amount);
      });
    });
    return list;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function ours(node) {
    for (var n = node; n; n = n.parentNode) {
      if (n.nodeType === 1 && n.hasAttribute('data-nk-tb')) return true;
      if (n.nodeType === 11) return false;
    }
    return false;
  }

  function initShadowRoot(sr) {
    if (sr.nkTbInit) return;
    sr.nkTbInit = true;
    ensureStyle(sr);

    var timer = null;
    function refresh() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        // Place immediately with the last known cart, then update with the fresh one.
        if (lastCart) render(sr, lastCart);
        fetchCart().then(function (cart) { lastCart = cart; render(sr, cart); }).catch(function () {});
      }, 150);
    }

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (!ours(records[i].target)) { refresh(); return; }
      }
    }).observe(sr, { childList: true, subtree: true, characterData: true });

    sr.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var s = sr.querySelector('.nk-tb-sheet');
      if (s && !s.hidden) { s.hidden = true; e.stopPropagation(); }
    }, true);

    refresh();
    // Once the excluded products are known, redraw with the last cart (the first render may have counted them).
    exclusionsReady.then(function () { if (lastCart) render(sr, lastCart); });
  }

  // ReCharge renders the drawer into its own host with an open shadow root (the shadow root exists
  // before the drawer is first opened, so observing it from the start catches every render).
  function findDrawer() {
    var host = document.getElementById('recharge-storefront-experiences__cart-drawer');
    if (host && host.shadowRoot) initShadowRoot(host.shadowRoot);
  }

  // The host can get its shadow root after being inserted (no further body mutation), so also poll
  // cheaply by id until the drawer is wired.
  new MutationObserver(findDrawer).observe(document.body, { childList: true });
  var poll = setInterval(function () {
    findDrawer();
    var host = document.getElementById('recharge-storefront-experiences__cart-drawer');
    if (host && host.shadowRoot && host.shadowRoot.nkTbInit) clearInterval(poll);
  }, 500);
  findDrawer();
})();
